import { useLottie } from 'lottie-react';
import recording from './recording.json';

const Recording = () => {
  const options = {
    animationData: recording,
    loop: true,
    autoplay: true,
  };

  const { View } = useLottie(options);

  return View;
};

export default Recording;
